import styled from 'styled-components'

export const InputContainer = styled.div`

border: 1px solid #FAFAFA;
border-radius: 20px;

margin-top: 20px;

height: 62px;
width: 80%;

input{
    background: transparent;
    padding: 0 20px;
    width: 100%;
    height: 62px;
    border: 0;
    outline: 0;
    color: #FFFFFF;
}


`